import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  AddCartItemRQ,
  UpdateCartRQ,
} from '../dto/request/shopping-cart.request';
import { ShoppingCart } from '../dto/response/shopping-cart.response';

@Injectable({
  providedIn: 'root',
})
export class ShoppingCartService {
  public cartLoader: boolean;
  public sideBarOpen: boolean = false;

  constructor(private http: HttpClient) { }

  getMyCart(cartId: string): Observable<ShoppingCart> {
    this.cartLoader = true;
    return this.http
      .get<ShoppingCart>(
        `${environment.baseURL}${environment.SHOPPING_CART}/` + cartId,
      )
      .pipe(
        finalize(() => {
          this.cartLoader = false;
        }),
      );
  }

  addToCart(cartItem: AddCartItemRQ) {
    this.cartLoader = true;
    console.log(
      'calling',
      `${environment.baseURL}${environment.SHOPPING_CART}/add-to-cart`,
    );
    console.log('calling ', cartItem);



    return this.http
      .post<ShoppingCart>(
        `${environment.baseURL}${environment.SHOPPING_CART}/add-to-cart`,
        cartItem,
      )
      .pipe(
        finalize(() => {
          console.log(
            'called',
            `${environment.baseURL}${environment.SHOPPING_CART}/add-to-cart`,
          );
          this.cartLoader = false;
        }),
      );
  }

  updateCart(updateCartRQ: UpdateCartRQ) {
    this.cartLoader = true;
    return this.http
      .put<ShoppingCart>(
        `${environment.baseURL}${environment.SHOPPING_CART}`,
        updateCartRQ,
      )
      .pipe(
        finalize(() => {
          this.cartLoader = false;
        }),
      );
  }
}
